export default __webpack_public_path__ + "static/matthew_pawers-088f9554cf36bc95b8183b2ad4ce31cb.jpg";